import { Pipe, PipeTransform } from '@angular/core';
import { FormatNumberHelper } from '@core/helpers/format-number.helper';

@Pipe({
    name: 'largeNumber',
    standalone: false
})
export class LargeNumberPipe implements PipeTransform {
  transform(value: string | number): string | number {
    const length = FormatNumberHelper.numberLength(value);
    if (length >= 4) {
      return `${value.toString().substring(0, length - 3)}k`;
    } else {
      return value;
    }
  }
}
